import React, { useState, useEffect, useRef } from "react";

/** Components */
import { Grid, TextField, Button, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper } from "@mui/material";
import FileInput from "../../commons/FileInput.component";
import ButtonWithAPICall from "../../commons/ButtonWithAPICall.component";
import CustomDatePicker from "../../commons/CustomDatePicker";

/** Icons */

/** Api & Function */
import { createPI, parseXML } from "../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";

/** Package */
import axios from "axios";
import moment from "moment";

/** Hook */
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

const initialInput = {
  pmode: 1,
  form: "",
  serial: "",
  code: "",
  date: "",

  contract_no: "",
  contract_date: "",

  provider: null,
  provider_name: "",
  provider_tax: "",
  provider_address: "",

  customer_name: "",
  customer_tax: "",
  customer_address: "",

  amount: "",
  vat: "",
  vat_rate: 0,
  total: "",
  in_word: "",
  xml: "",
  pdf: "",
  products: [],

  itemcost: null,
  link: "",
  note: "",
};
const CreatePI = () => {
  // custom hook
  const [t] = useTranslation();
  const dispatch = useDispatch();

  // state
  const [input, setInput] = useState({ ...initialInput });
  const ref = useRef({
    apiGetXML: null,
  });
  // method
  const handleSubmit = () => {
    const files = new FormData();
    files.append("pmode", input.pmode);
    input.xml && files.append("xml", input.xml);
    input.pdf && files.append("pdf", input.pdf);
    input.form && files.append("form", input.form);
    input.serial && files.append("serial", input.serial);
    input.code && files.append("code", input.code);
    input.date && files.append("date", moment(input.date).format("YYYY-MM-DD"));
    input.contract_no && files.append("contract_no", input.contract_no);
    input.provider?.id && files.append("provider_id", input.provider?.id);
    input.provider_name && files.append("provider_name", input.provider_name);
    input.provider_tax && files.append("provider_tax", input.provider_tax);
    input.provider_address && files.append("provider_address", input.provider_address);
    input.customer_name && files.append("customer_name", input.customer_name);
    input.customer_tax && files.append("customer_tax", input.customer_tax);
    input.customer_address && files.append("customer_address", input.customer_address);
    files.append("amount", input.amount || 0);
    files.append("vat", input.vat || 0);
    files.append("vat_rate", input.vat_rate || 0);
    files.append("total", input.total || 0);
    input.in_word && files.append("in_word", input.in_word);
    input.link && files.append("link", input.link);
    input.note && files.append("note", input.note);
    input.itemcost?.id && files.append("itemcost_id", input.itemcost?.id);
    input.products && files.append("products", JSON.stringify(input.products));
    return createPI(files);
  };

  // effect
  useEffect(() => {
    if (!input.xml) return;
    const form = new FormData();
    form.append("file", input.xml);

    // cancel api cu
    ref.current.apiGetXML?.cancel();
    const source = axios.CancelToken.source();
    ref.current.apiGetXML = source;

    parseXML(form, { cancelToken: source.token }).then((res) => {
      if (res.code === 200) {
        setInput((prev) => ({ ...prev, ...res.data }));
      }
    });
  }, [input.xml]);

  useEffect(() => {
    dispatch(setHeaderTitle("NHẬP MỚI THÔNG TIN HOÁ ĐƠN ĐẦU VÀO"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Paper align="left" style={{ margin: 10, marginTop: 30 }}>
      <Grid container spacing={2} columns={10} style={{ marginLeft: 3, width: "99%" }}>
        <Grid item sm={1} xs={2}>
          XML file
        </Grid>
        <Grid item sm={3} xs={3}>
          <FileInput accept=".xml" fullWidth value={input.xml} onChange={(file) => setInput((prev) => ({ ...prev, xml: file }))} />
        </Grid>
        <Grid item sm={1} xs={2}>
          PDF file
        </Grid>
        <Grid item sm={3} xs={3}>
          <FileInput accept=".pdf" fullWidth value={input.pdf} onChange={(file) => setInput((prev) => ({ ...prev, pdf: file }))} />
        </Grid>
        <Grid item sm={2} />

        <Grid item sm={1} xs={2}>
          {t("Tên người bán")}
        </Grid>
        <Grid item sm={6} xs={8}>
          <TextField fullWidth value={input.provider_name} onChange={(e) => setInput((prev) => ({ ...prev, provider_name: e.target.value }))} />
        </Grid>

        <Grid item sm={1} xs={2}>
          {t("Mã số thuế người bán")}
        </Grid>
        <Grid item sm={2} xs={3}>
          <TextField fullWidth value={input.provider_tax} onChange={(e) => setInput((prev) => ({ ...prev, provider_tax: e.target.value, provider: null }))} />
        </Grid>
        <Grid item sm={1} xs={2}>
          {t("Địa chỉ người bán")}
        </Grid>
        <Grid item sm={9} xs={8}>
          <TextField fullWidth value={input.provider_address} onChange={(e) => setInput((prev) => ({ ...prev, provider_address: e.target.value }))} />
        </Grid>
        {/* <Grid item sx={5} sm={6}/> */}
        <Grid item sm={1} xs={2}>
          {t("Tên người mua")}
        </Grid>
        <Grid item sm={6} xs={8}>
          <TextField fullWidth value={input.customer_name} onChange={(e) => setInput((prev) => ({ ...prev, customer_name: e.target.value }))} />
        </Grid>
        <Grid item sm={1} xs={2}>
          {t("Mã số thuế người mua")}
        </Grid>
        <Grid item sm={2} xs={3}>
          <TextField fullWidth value={input.customer_tax} onChange={(e) => setInput((prev) => ({ ...prev, customer_tax: e.target.value, provider: null }))} />
        </Grid>
        <Grid item sm={1} xs={2}>
          {t("Địa chỉ người mua")}
        </Grid>
        <Grid item sm={9} xs={8}>
          <TextField fullWidth value={input.customer_address} onChange={(e) => setInput((prev) => ({ ...prev, customer_address: e.target.value }))} />
        </Grid>

        {/* <Grid item sm={6} sx={5}/> */}
        <Grid item sm={1} xs={2}>
          {t("Thông tin HĐ")}
        </Grid>
        <Grid item sm={2} xs={3}>
          <TextField label={t("Mẫu số")} fullWidth value={input.form} onChange={(e) => setInput((prev) => ({ ...prev, form: e.target.value }))} />
        </Grid>
        <Grid item sm={2} xs={3}>
          <TextField label={t("Ký hiệu")} fullWidth value={input.serial} onChange={(e) => setInput((prev) => ({ ...prev, serial: e.target.value }))} />
        </Grid>
        <Grid item sm={2} xs={3}>
          <TextField
            label={t("Số hóa đơn") + (input.code && input.code.length !== 7 && input.code.length !== 8 ? " (Sai định dạng)" : "")}
            fullWidth
            value={input.code}
            onChange={(e) => setInput((prev) => ({ ...prev, code: e.target.value }))}
            error={input.code && input.code.length !== 7 && input.code.length !== 8}
          />
        </Grid>
        <Grid item sm={2} xs={3}>
          <CustomDatePicker label={t("Ngày xuất hóa đơn")} value={input.date} onChange={(value) => setInput((prev) => ({ ...prev, date: value }))} />
        </Grid>
        <Grid item sm={1} />
        <Grid item sm={1}>
          {t("Thông tin HH")}
        </Grid>
        <Grid item sm={2} xs={2}>
          <TextField label={t(t("Tiền trước thuế (VND)"))} fullWidth value={input.amount} onChange={(e) => setInput((prev) => ({ ...prev, amount: e.target.value }))} />
        </Grid>
        <Grid item sm={2} xs={2}>
          <TextField
            type="number"
            sx={{ width: "100%" }}
            label={t("Thuế") + " (%)"}
            value={input.vat_rate}
            onChange={(e) => setInput((prev) => ({ ...prev, vat_rate: e.target.value < 0 ? 0 : e.target.value > 100 ? 100 : e.target.value }))}
          />
        </Grid>
        <Grid item sm={2} xs={2}>
          <TextField fullWidth label={t("Tiền thuế")} value={input.vat} onChange={(e) => setInput((prev) => ({ ...prev, vat: e.target.value }))} />
        </Grid>
        <Grid item sm={2} xs={2}>
          <TextField fullWidth label={t("Tổng tiền sau thuế")} value={input.total} onChange={(e) => setInput((prev) => ({ ...prev, total: e.target.value }))} />
        </Grid>
        <Grid item sm={1} sx={{ display: { xs: "none", sm: "inherit" } }} />
        <Grid item sm={1} xs={2}>
          {t("Link web")}
        </Grid>
        <Grid item sm={3} xs={8}>
          <TextField multiline minRows={2} fullWidth value={input.link} onChange={(e) => setInput((prev) => ({ ...prev, link: e.target.value }))} />
        </Grid>
        <Grid item sm={1} xs={2}>
          {t("Ghi chú")}
        </Grid>
        <Grid item sm={4} xs={8}>
          <TextField multiline minRows={2} fullWidth value={input.note} onChange={(e) => setInput((prev) => ({ ...prev, note: e.target.value }))} />
        </Grid>
        <Grid item sm={1} />
      </Grid>
      <ProductTable data={input.products} />
      <ButtonWithAPICall style={{ margin: "10px" }} variant="contained" api={handleSubmit}>
        {t("Lưu")}
      </ButtonWithAPICall>
      <Button color="error" style={{ margin: "10px" }} variant="contained" onClick={() => setInput({ ...initialInput })}>
        {t("Hủy")}
      </Button>
    </Paper>
  );
};

const ProductTable = ({ data }) => {
  const { t } = useTranslation();
  if (data)
    return (
      <div style={{ marginTop: 20 }}>
        <div style={{ padding: 10, fontSize: 17, backgroundColor: "#f0f3f5", marginTop: 20, marginBottom: 2, textTransform: "uppercase" }} align="center">
          {t("Thông tin hàng hóa")}
        </div>
        <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell style={{ border: "0.5px solid lightgray" }}>STT</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>Hình thức</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>Hàng hóa</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>Mã HH</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>ĐVT</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>Số lượng</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>Đơn giá</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>% Chiết khẩu</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>Tiền CK</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>Thành tiền</TableCell>
                <TableCell style={{ border: "0.5px solid lightgray" }}>Thuế suất</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((item, index) => (
                <TableRow key={index}>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>{item.no}</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}></TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>{item.product}</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}></TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>{item.unit}</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>{item.quantity?.toLocaleString()}</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>{Math.round(item?.price)?.toLocaleString()}</TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}></TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}></TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }} align="right">
                    {Math.round(item?.total)?.toLocaleString()}
                  </TableCell>
                  <TableCell style={{ border: "0.5px solid lightgray" }}>{item.vat_rate}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    );
  return "";
};

export default CreatePI;
